import { render, staticRenderFns } from "./DynamicLabel.vue?vue&type=template&id=b9328c28&"
import script from "./DynamicLabel.vue?vue&type=script&lang=js&"
export * from "./DynamicLabel.vue?vue&type=script&lang=js&"
import style0 from "./DynamicLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports